import { render } from "./ResidualTable.vue?vue&type=template&id=1f56ec1c&scoped=true&ts=true"
import script from "./ResidualTable.ts?vue&type=script&lang=ts"
export * from "./ResidualTable.ts?vue&type=script&lang=ts"

import "./ResidualTable.scss?vue&type=style&index=0&id=1f56ec1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f56ec1c"]])

export default __exports__